<template>
  <Modal
    :ref="'wp-next-reviewer-modal'"
    :modalType="modalType"
    className="wp-nextreviewer-modal"
  >
    <slot name="wp-next-reviewer-content" />
    <label class="modal-lable required-flag">{{ labelContext }}</label>
    <HKLSelect
      class="wp-next-reviewer-select"
      :value="payloadId || undefined"
      :options="reviewerHklOptions"
      :showSearch="true"
      :required="true"
      placeholder=""
      @change="onReviewerChange"
    />
    <slot name="additional-content" />
    <div slot="btns">
      <button
        class="btn btn--darkblue"
        @click="closeModal"
      >{{ noBtnContext }}</button>
      <button
        class="btn btn--orange"
        @click="submit"
      >{{ okBtnContext }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/controls/Modal'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import i18n from '@/utils/i18n'
import { getNextReviewerOptions } from './utils'
import { wpNextReviewerLabel } from './consts'

export default {
  name: 'WorkPermNextReviewerModal',
  components: {
    Modal,
    HKLSelect,
  },
  props: {
    /**
     * modalId
     * @type {String}
     * @requires true
     */
    modalType: {
      type: String,
      default: 'small-modal', // medium-modal large-modal
    },
    /**
     * Context of Button for ok action
     * @default 'submit'
     * @type {String}
     */
    okBtnContext: {
      type: String,
      default: i18n.t('action.submit'),
    },
    /**
     * Context of Button for no action
     * @default 'cancel'
     * @type {String}
     */
    noBtnContext: {
      type: String,
      default: i18n.t('action.cancel'),
    },
    excludeCurrent: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      multiSelectOptions: [],
      labelContext: '',
      payload: null,
      payloadId: null,
    }
  },
  computed: {
    reviewerHklOptions () {
      return (this.multiSelectOptions || []).map((opt) => ({
        name: opt.displayPicName,
        value: opt.id,
      }))
    },
  },
  methods: {
    async openModal (action, data) {
      const actionLabel = wpNextReviewerLabel()
      this.multiSelectOptions = await getNextReviewerOptions(action, data, this.excludeCurrent)
      this.labelContext = actionLabel[action]
      fusionInputCheckUtil.resetAllFields()
      this.payload = null
      this.payloadId = null
      this.$refs['wp-next-reviewer-modal'].open()
    },
    closeModal () {
      this.$refs['wp-next-reviewer-modal'].close()
    },
    onReviewerChange (id) {
      this.payloadId = id || null
      this.payload = (this.multiSelectOptions || []).find((opt) => opt.id === id) || null
    },
    submit () {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.wp-nextreviewer-modal')
      if (!this.payload) return

      this.closeModal()
      this.$emit('multi-select-submited', this.payload)
    },
  },
}
</script>

<style lang="scss" scoped>
.wp-nextreviewer-modal {
  &__content {
    margin-top: 10px;
  }
}
.modal-lable {
  font-weight: bold
}
.wp-next-reviewer-select {
  width: 100%;
}
</style>
